"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPaymentInfoEvent = void 0;
const abstract_sales_event_1 = require("./abstract-sales.event");
class AddPaymentInfoEvent extends abstract_sales_event_1.AbstractSalesEvent {
    constructor(config) {
        super(config);
        this.config = config;
        this.name = 'add_payment_info';
    }
    getData() {
        var _a, _b, _c, _d;
        return {
            currency: this.config.currency,
            value: this.config.value,
            coupon: this.config.coupon,
            paymentMethod: this.config.paymentMethod,
            items: Array.isArray(this.config.items) ? this.config.items.map(item => (Object.assign({}, item))) : [],
            customer: this.config.customer ? {
                firstname: (_a = this.config.customer) === null || _a === void 0 ? void 0 : _a.firstname,
                lastname: (_b = this.config.customer) === null || _b === void 0 ? void 0 : _b.lastname,
                email: (_c = this.config.customer) === null || _c === void 0 ? void 0 : _c.email,
                telephone: (_d = this.config.customer) === null || _d === void 0 ? void 0 : _d.telephone
            } : undefined
        };
    }
}
exports.AddPaymentInfoEvent = AddPaymentInfoEvent;
//# sourceMappingURL=add-payment-info.event.js.map